import { QueryKeys as SharedQueryKeys } from "@akina/infra";

export const QueryKeys = {
  ...SharedQueryKeys,
  webshopRegistrationStatus: "webshopRegistrationStatus",
} as const;
